(function () {
  const $formFiltros = $('.form-filtros');
  if ($formFiltros.length > 0) {
    const $opcaoInput = $('#opcoes');
    const $containerTabela = $('.container-tabela-opcoes');
    const $tabelaProdutosFiltros = $('.tabela-produtos-filtros');
    const colorOpcaoDefault = '';
    let opcoes_json = $('input[name="opcoes_json"]').val();
    const opcoesTag = [];
    const htmlLinhaTabelaOpcao = (item) => `
    <tr data-row="${item.id}">
    <td data-label="Opção:">
      <input type="text" name="title_opcao[${
        item.id
      }]" class="form-control" style="font-size: 14px; font-weight: 600;" maxlength="255" readonly value="${
      item.title
    }">
    </td>
    <td data-label="Cor:">
      <div class="input-group my-colorpicker2 colorpicker-element">
        <input type="text" id="colorpicker-id-${item.id}" name="color[${
      item.id
    }]" class="form-control input-colorpicker" data-parsley-trigger="change" data-original-title="" value="${
      item.color
    }" title="Cor">
        <div class="input-group-append">
          <span class="input-group-text"><i class="las la-square" style="color: ${item.color || '#FFF'};"></i></span>
        </div>
      </div>
    </td>
    <td data-label="Imagem:">
      <div class="form-ezdz">
        <input type="file" name="img[${item.id}][image]" id="ezdz-id-${
      item.id
    }" class="ezdz" accept="image/*" data-parsley-trigger="change" ${
      item['image_main'] ? `data-value="${item['image_main']}"` : ''
    }">
      </div>
    </td>
  </tr>`;

    // input tags
    $('.tags-filtro').tagsinput('destroy');
    $('.tags-filtro').tagsinput({
      trimValue: true,
      delimiter: [','],
    });

    // Adiciona itens cadastrados se houver
    if (opcoes_json && opcoes_json.length > 0) {
      try {
        opcoes_json = JSON.parse(opcoes_json);
        opcoes_json.forEach((opcao) => {
          //console.log(opcao);
          $opcaoInput.tagsinput('add', opcao.title);
          opcaoAdd.apply(this, [opcao.title, opcao.id, opcao.color, opcao['image_main']]);
        });
      } catch (e) {
        console.log(e);
      }
    }

    $('.tags-filtro').on('beforeItemAdd', function (event) {});

    function checked(status) {
      if (status == 1) return 'checked';
      else return '';
    }

    function opcaoAdd(opcaoTitle, id = null, color = null, image_main = null) {
      const objFilter = {
        title: opcaoTitle,
        id: id ? id : generateOpcaoId(),
        color: color ? color : colorOpcaoDefault,
        image_main: image_main ? image_main : '',
      };
      opcoesTag.push({
        id: objFilter.id,
        title: opcaoTitle,
      });
      addLinhaItem(objFilter);
    }

    function opcaoRemoved(opcao) {
      var opcaoRemoved = opcoesTag.find((item) => item.title == opcao);
      console.log($tabelaProdutosFiltros.find(`tbody tr[data-row="${opcaoRemoved.id}"]`)[0]);
      $tabelaProdutosFiltros.find(`tbody tr[data-row="${opcaoRemoved.id}"]`).remove();
    }

    $opcaoInput.on('itemAdded itemRemoved', function (event) {
      if (event.type == 'itemAdded') {
        opcaoAdd.apply(this, [event.item]);
      } else if (event.type == 'itemRemoved') {
        opcaoRemoved.apply(this, [event.item]);
      }
    });

    $tabelaProdutosFiltros.on('keyup', function (ev) {
      if ($(ev.target).attr('name').includes('titulo_opcao')) {
        var $inputOpcao = $(ev.target);
        console.log($inputOpcao.val());
      }
    });

    function addLinhaItem(item) {
      //console.log(item);
      $tabelaProdutosFiltros.find('tbody').append(htmlLinhaTabelaOpcao(item));
      $containerTabela.show();
      inputEzdzCreated(item.id);
      inputColorPickerCreated(item.id);
    }

    function opcaoTagAdd(opcao) {
      opcoesTag.push(opcao);
    }
    function opcaoTagRemove(opcao) {
      var indexOf = opcoesTag.indexOf(opcao);
      opcoesTag.splice(indexOf, 1);
    }

    // Inicia ezdz para o input que foi adicionado dinâmicamente
    function inputEzdzCreated(itemId) {
      $(document).trigger('input.ezdz.dinamico', [`ezdz-id-${itemId}`]);
    }

    // Inicia colorpicker para o input que foi adicionado dinâmicamente
    function inputColorPickerCreated(itemId) {
      $(document).trigger('input.colorpicker.dinamico', [`colorpicker-id-${itemId}`]);
    }

    function generateOpcaoId() {
      const $tableProdutosLinhas = $('.tabela-produtos-filtros').find('tbody tr');
      //console.log($tableProdutosLinhas.last()[0]);
      if ($tableProdutosLinhas.length > 0) {
        return Number($tableProdutosLinhas.last().data('row')) + 1;
      } else {
        return 1;
      }
    }
  }
})();
